import Vue from 'vue'
import Router from 'vue-router'
import authService from '@/services/auth'
import {roleFeatures as accountFeatures}  from '@/assets/utils/user_roles'
import { PMRole } from '@/assets/utils/user_roles'
import store from '@/store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    // =============================================================================
    // HOME LAYOUT ROUTES
    // =============================================================================
    {
      path: '',
      component: () => import('./layouts/home/Home.vue'),
      children: [
        {
          path: '/404-notfound',
          name: '404-notfound',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            permission: '*'
          }
        },
        {
          path: '/search',
          name: 'search',
          component: () => import('@/views/home/search/Search.vue'),
          meta: {
            permission: '*'
          }
        },
        // {
        //   path: '/notification',
        //   component: () => import('@/views/home/notification/Notification.vue'),
        //   meta: {
        //     permission: '*'
        //   }
        // },
        // {
        //   path: '/message',
        //   component: () => import('@/views/home/message/Message.vue'),
        //   meta: {
        //     permission: '*'
        //   }
        // },
        {
          path: '/verify/:id',
          component: () => import('@/views/home/auth/VerifyRegister.vue'),
          meta: {
            permission: 'guest'
          }
        },
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          component: () => import('@/views/home/Home.vue'),
          meta: {
            permission: '*'
          }
        },
        {
          path: '/faq',
          component: () => import('@/views/home/faq/Faq.vue'),
          meta: {
            permission: '*'
          }
        },
        // =============================================================================
        // CAMPAIGN
        // =============================================================================
        {
          path: '/campaign',
          component: () => import('@/views/home/campaign/Campaign.vue'),
          meta: {
            permission: '*'
          }
        },
        {
          path: '/campaign/:id/pm-list',
          component: () => import('@/views/home/campaign/CampaignPMList.vue'),
          meta: {
            permission: '*'
          }
        },
        {
          path: '/campaign/:id/pm-request',
          component: () => import('@/views/home/campaign/CampaignPM.vue'),
          meta: {
            permission: PMRole,
            authRequired: true
          }
        },
        // {
        //   path: '/campaign/:id/checkout/choose-payment',
        //   component: () => import('@/views/home/campaign/CampaignPaymentOption.vue'),
        //   meta: {
        //     permission: '*'
        //   }
        // },
        // =============================================================================
        // NEWS
        // =============================================================================
        {
          path: '/news',
          component: () => import('@/views/home/news/News.vue'),
          meta: {
            permission: '*'
          }
        },
        {
          path: '/news/:id/detail',
          component: () => import('@/views/home/news/NewsDetail.vue'),
          meta: {
            permission: '*'
          }
        },
        // =============================================================================
        // DONATION
        // =============================================================================
        {
          path: '/donasi',
          component: () => import('@/views/home/donation/Donation.vue'),
          meta: {
            permission: '*'
          }
        },
        // =============================================================================
        // ZAKAT
        // =============================================================================
        {
          path: '/bayar-zis/complete_pay',
          component: () => import('@/views/home/zis/ZisPaymentComplete.vue'),
          meta: {
            permission: 'muzaki,mustahik'
          }
        },
        // =============================================================================
        // KALKULATOR ZAKAT
        // =============================================================================
        {
          path: '/kalkulator-zakat',
          component: () => import('@/views/home/zakat-calculator/ZakatCalculator.vue'),
          meta: {
            permission: '*'
          }
        },
        {
          path: '/loading',
          component: () => import('@/views/components/vuesax/loading/Loading.vue'),
          meta: {
            permission: '*'
          }
        },
        // =============================================================================
        // TRACKING QURBAN
        // ==============================================================================
        {
          path: '/track-qurban',
          component: () => import('@/views/home/qurban/tracking/QurbanTracking.vue'),
          meta: {
            permission: '*',
            authRequired: true
          }
        },
        {
          path: '/track-qurban/result',
          component: () => import('@/views/home/qurban/tracking/QurbanTrackingResult.vue'),
          meta: {
            permission: '*',
            authRequired: true
          }
        },
        // =============================================================================
        // PROFILE
        // =============================================================================
        {
          path: '/profile',
          component: () => import('@/views/home/user/Profile.vue'),
          meta: {
            permission: '*',
            authRequired: true
          }
        },
        {
          path: '/profile/verify',
          component: () => import('@/views/home/user/ProfileVerify.vue'),
          meta: {
            permission: '*',
            authRequired: true
          }
        },
        // =============================================================================
        // BALANCE
        // =============================================================================
        // {
        //   path: '/balance/confirm',
        //   component: () => import('@/views/home/balance/BalancePaymentConfirm.vue'),
        //   meta: {
        //     authRequired: true
        //   }
        // },
        // {
        //   path: '/balance/checkout',
        //   component: () => import('@/views/home/balance/Balance.vue'),
        //   meta: {
        //     authRequired: true
        //   }
        // },
        // {
        //   path: '/balance/choose-payment',
        //   component: () => import('@/views/home/balance/BalancePaymentMethod.vue'),
        //   meta: {
        //     authRequired: true
        //   }
        // },
        // {
        //   path: '/balance/transfer',
        //   component: () => import('@/views/home/balance/BalanceTransfer.vue'),
        //   meta: {
        //     permission: '*',
        //     authRequired: true
        //   }
        // },
        // {
        //   path: '/balance/withdraw',
        //   component: () => import('@/views/home/balance/BalanceWithdraw.vue'),
        //   meta: {
        //     permission: '*',
        //     authRequired: true
        //   }
        // },
        // {
        //   path: '/top-up-tagihan',
        //   component: () => import('@/views/home/ppob/PPOB.vue'),
        //   meta: {
        //     permission: '*'
        //   }
        // },
        // =============================================================================
        // HISTORY TRANSACTION
        // =============================================================================
        {
          path: '/history-transaction',
          component: () => import('@/views/home/balance/HistoryTransaction.vue'),
          meta: {
            permission: '*',
            authRequired: true
          }
        },
        // =============================================================================
        // ACCOUNT SECURITY
        // =============================================================================
        // {
        //   path: '/account-security',
        //   component: () => import('@/views/home/user/security-account/SecurityAccount.vue'),
        //   meta: {
        //     permission: '*',
        //     authRequired: true
        //   }
        // },
        // =============================================================================
        // MY ACCOUNT
        // =============================================================================
        {
          path: '/profile/success',
          component: () => import('@/views/home/user/ProfileUpdateSuccess.vue'),
          meta: {
            permission: '*',
            authRequired: true
          }
        },
        {
          path: '/profile/edit',
          component: () => import('@/views/home/user/ProfileEdit.vue'),
          meta: {
            permission: '*',
            authRequired: true
          }
        },
        {
          path: '/my-account',
          component: () => import('@/views/home/user/my-account/MyAccount.vue'),
          meta: {
            permission: Object.keys(accountFeatures).join(','),
            authRequired: true
          }
        },
        {
          path: '/pagination',
          name: 'pagination',
          component: () => import('@/views/components/vuesax/pagination/Pagination.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    },
    // =============================================================================
    // LAYANAN
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/Kesehatan.vue'),
      children: [
        {
          path: '/layanan/:id',
          name: 'layanan',
          component: () => import('@/views/home/sos/Service.vue'),
          meta: {
            permission: '*'
          }
        }
      ]
    },
    // =============================================================================
    // Qurban Detail
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/Campaign.vue'),
      children: [
        {
          path: '/qurban/view/:slug_and_id',
          component: () => import('@/views/home/qurban/QurbanDetail.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Qurban'
          }
        },
        {
          path: '/qurban/view/:slug_and_id/:referal',
          component: () => import('@/views/home/qurban/QurbanDetail.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Qurban'
          }
        },
        {
          path: '/qurban/checkout/:slug_and_id',
          component: () => import('@/views/home/qurban/QurbanCheckout.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Qurban'
          }
        },
        {
          path: '/qurban/choose-payment/:slug_and_id',
          component: () => import('@/views/home/qurban/QurbanPaymentOption.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Qurban'
          }
        },
        {
          path: '/qurban/confirm/:slug_and_id',
          component: () => import('@/views/home/qurban/QurbanPaymentConfirm.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Konfirmasi Pembayaran'
          }
        },
        {
          path: '/qurban/niat/:slug_and_id',
          component: () => import('@/views/home/qurban/QurbanNiat.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Niat Qurban'
          }
        },
        {
          path: '/qurban/complete/:slug_and_id',
          component: () => import('@/views/home/qurban/QurbanPaymentComplete.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Konfirmasi Pembayaran'
          }
        }
      ]
    },
    // =============================================================================
    // Campaign Detail
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/Campaign.vue'),
      children: [
        // {
        //   path: '/campaign/:id/detail',
        //   component: () => import('@/views/home/campaign/CampaignDetail.vue'),
        //   meta: {
        //     permission: '*',
        //     pageTitle: 'Donasi'
        //   }
        // },
        {
          path: '/campaign/view/:slug_and_id',
          component: () => import('@/views/home/campaign/CampaignDetailSlug.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Donasi'
          }
        },
        {
          path: '/campaign/view/:slug_and_id/:referal',
          props: (route) => ({
            slug_and_id: route.params.slug_and_id,
            referal: route.params.referal || ''
          }),
          component: () => import('@/views/home/campaign/CampaignDetailSlug.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Donasi'
          }
        },
        {
          path: '/campaign/:id/request-pm',
          component: () => import('@/views/home/campaign/CampaignPM.vue'),
          meta: {
            permission: 'mitra,user',
            pageTitle: 'Donasi',
            authRequired: true
          }
        },
        {
          path: '/campaign/:id/success-pm',
          component: () => import('@/views/home/campaign/CampaignPMComplete.vue'),
          meta: {
            permission: 'mitra,user',
            pageTitle: 'Donasi',
            authRequired: true
          }
        }
      ]
    },
    // =============================================================================
    // AUTH ROUTES
    // =============================================================================
    {
      path: '',
      component: () => import('./layouts/full-page/Auth.vue'),
      children: [
        {
          path: '/login',
          component: () => import('@/views/home/auth/Login.vue'),
          meta: {
            pageTitle: 'Login',
            permission: 'guest'
          }
        },
        {
          path: '/register',
          component: () => import('@/views/home/auth/Register.vue'),
          meta: {
            pageTitle: 'Register',
            permission: 'guest'
          }
        },
        {
          path: '/forgot-password/:id',
          name: 'reset-password',
          component: () => import('@/views/home/auth/ResetPassword.vue'),
          meta: {
            permission: 'guest'
          }
        },
        {
          path: '/forgot-password',
          component: () => import('@/views/home/auth/ForgotPassword.vue'),
          meta: {
            pageTitle: 'Lupa Password',
            permission: 'guest'
          }
        },
        {
          path: '/confirm-your-email',
          component: () => import('@/views/home/auth/ConfirmEmail.vue'),
          meta: {
            pageTitle: 'Konfirmasi Email',
            permission: 'guest'
          }
        }
      ]
    },
    // =============================================================================
    // Campaign Transaction
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/CampaignTransaction.vue'),
      children: [
        {
          path: '/campaign/donation-amount/:slug_and_id',
          component: () => import('@/views/home/campaign/CampaignDonation.vue'),
          meta: {
            verifyAccountRequired: true,
            permission: '*',
            pageTitle: 'Donasi'
          }          
        },
        {
          path: '/campaign/checkout/:slug_and_id',
          component: () => import('@/views/home/campaign/CampaignCheckout.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Donasi',
            verifyAccountRequired: true
          }
        },
        {
          path: '/campaign/confirm/:slug_and_id',
          component: () => import('@/views/home/campaign/CampaignCheckoutConfirm.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Donasi',
            verifyAccountRequired: true
          }
        },
        {
          path: '/campaign/complete/:slug_and_id',
          component: () => import('@/views/home/campaign/CampaignCheckoutComplete.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Donasi',
            verifyAccountRequired: true
          }
        }
      ]
    },
    // =============================================================================
    // Token Listrik
    // =============================================================================
    
    // =============================================================================
    // Pulsa
    // =============================================================================
    
    // =============================================================================
    // Paket Data
    // =============================================================================
    /// },
    
    // =============================================================================
    // Zakat, Infak, sedekah
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/Zakat.vue'),
      children: [
        {
          path: '/bayar-zis',
          component: () => import('@/views/home/zis/ZisPayment.vue'),
          meta: {
            permission: 'user,sahabat_zx',
            pageTitle: 'Bayar',
            verifyAccountRequired: true
          }
        },
        {
          path: '/bayar-zis/choose-payment',
          component: () => import('@/views/home/zis/ZisPaymentOption.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Bayar',
            verifyAccountRequired: true
          }
        },
        {
          path: '/bayar-zis/payment-confirm',
          component: () => import('@/views/home/zis/ZisPaymentConfirm.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Bayar',
            verifyAccountRequired: true
          }
        },
        {
          path: '/bayar-zis/complete',
          component: () => import('@/views/home/zis/ZisPaymentComplete.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Bayar',
            verifyAccountRequired: true
          }
        }
      ]
    },
    // =============================================================================
    // ZX Care
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/ZXCare.vue'),
      children: [
        {
          path: '/zxcare',
          name: 'zxcare',
          component: () => import('@/views/home/zxcare/ZXCare.vue'),
          meta: {
            permission: '*',
            pageTitle: 'ZX Care'
          }
        },
        {
          path: '/zxcare/qurban',
          name: 'zxcare',
          component: () => import('@/views/home/zxcare/Qurban.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Qurban'
          }
        }
      ]
    },
    // =============================================================================
    // Mitra
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/Mitra.vue'),
      children: [
        {
          path: '/sahabat-zx/:slug_and_id',
          props: (route) => ({
            slug_and_id: route.params.slug_and_id
          }),
          name: 'sahabat-zx-lp',
          component: () => import('@/views/home/sahabat-zx/SahabatZXLp.vue'),
          meta: {
            permission: '*'
          }
        },
        // Landing Page Sahabat with Referal code
        {
          path: '/sahabat-zx/:slug_and_id/:referal',
          props: (route) => ({
            slug_and_id: route.params.slug_and_id,
            referal: route.params.referal || ''
          }),
          name: 'sahabat-zx-lp-ref',
          component: () => import('@/views/home/sahabat-zx/SahabatZXLpRef.vue'),
          meta: {
            permission: '*'
          }
        }
      ]
    },
    // =============================================================================
    // SAHABAT ZX
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/SahabatZX.vue'),
      children: [
        {
          path: '/sahabat-zx',
          name: 'sahabat-zx',
          component: () => import('@/views/home/sahabat-zx/SahabatZX.vue'),
          meta: {
            permission: '*'
          }
        }
      ]
    },
    // =============================================================================
    // KEBIJAKAN PRIVACY LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/Page.vue'),
      children: [
        {
          path: '/privacy-policy',
          name: 'privacy-policy',
          component: () => import('@/views/home/privacy-policy/PrivacyPolicy.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Kebijakan & Privasi'
          }
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('@/views/home/about/About.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Tentang ZX'
          }
        },
        {
          path: '/mitra',
          name: 'mitra',
          component: () => import('@/views/home/mitra/Mitra.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Mitra ZX'
          }
        },
        {
          path: '/terms-conditions',
          name: 'terms-conditions',
          component: () => import('@/views/home/terms-conditions/TermsConditions.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Syarat & Ketentuan'
          }
        },
        {
          path: '/promo',
          name: 'promo',
          component: () => import('@/views/home/promo/Promo.vue'),
          meta: {
            permission: '*',
            pageTitle: 'Promo'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/comingsoon'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {

  // If auth required, check login. If login fails redirect to login page
  if (to.meta.authRequired) {
    if (authService.emptyToken() == null) {
      router.push({ path: '/login', query: { to: to.path } })
    }
  }

  // Middleware for auth user enter to login
  if (authService.emptyToken() != null) {
    if (to.meta.permission == 'guest') {
      router.push('/')
    }
  }

  // Check if page need verify account only
  // if(to.meta.verifyAccountRequired) {
  // }

  return next()

})

export default router